<div class="sales-card-wrapper shadow-sm">
  <!-- Header -->
  <div class="d-flex justify-content-between align-items-center mb-3">
    <div class="d-flex align-items-center gap-2">
      <fa-icon [icon]="faChartColumn" class="icon-md" style="color: #00305C;"></fa-icon>
      <span class="sales-title fw-smbold">Sales</span>
      <span class="sales-badge fw-smbold">
        <!-- {{ salesBadgeValue }} -->
        {{totalInvoices}} invoices
      </span>
    </div>
    <button class="btn view-all-btn d-flex align-items-center gap-1" (click)="viewAllSales(salesModal)">
      View all sales <fa-icon [icon]="faChevronRight" class="text-blue" style="font-size: 10px;"></fa-icon>
    </button>
  </div>

  <!-- Loader State -->
  @if (loader) {
    <div class="d-flex justify-content-center py-5">
      <app-loader [loadingIcon]="loader"></app-loader>
    </div>
  }

  <!-- Error State -->
  @if (!loader && errMsg) {
    <div class="text-center py-4">
      <p class="text-danger mb-0 small fw-bold">{{ errMsg }}</p>
    </div>
  }

  <!-- Cards Grid -->
  @if (!loader && !errMsg) {
    <div class="row g-3">
      <!-- Branch Sales -->
      <div class="col-12 col-md-6">
        <div class="inner-card card-branch h-100">
          <div class="d-flex align-items-center gap-2 mb-3">
            <fa-icon [icon]="faLocationDot" class="text-muted icon-sm"></fa-icon>
            <span class="inner-card-title fw-smbold">Sales by Branch</span>
          </div>
          <table class="table table-borderless mb-0 bg-transparent">
            <thead>
              <tr class="custom-tr">
                <th class="table-header-text p-1 pb-2 text-muted bg-transparent border-0">Branch</th>
                <th class="table-header-text p-1 pb-2 text-muted text-end bg-transparent border-0">Tyres</th>
                <th class="table-header-text p-1 pb-2 text-muted text-end bg-transparent border-0">Sale Value</th>
              </tr>
            </thead>
            <tbody>
              @if (branchSales.length) {
                @for (item of branchSales; track item) {
                  <tr class="custom-tr cursor-pointer" (click)="onRowClick('branch', item)">
                    <td class="td-col-1 p-1 pt-2 pb-2 bg-transparent">{{ item.branch }}</td>
                    <td class="td-col-2 p-1 pt-2 pb-2 text-end fw-smbold bg-transparent">
                        {{ item.vol | customNumber }}
                    </td>
                    <td class="td-col-3 p-1 pt-2 pb-2 text-end bg-transparent">
                        {{ item.sales | customNumber }}
                    </td>
                  </tr>
                }
              }
              @if (branchSales.length == 0) {
                <td colspan="3" class="text-center py-4 border-0">
                  <p class="text-muted mb-0 small fw-bold">No data found.</p>
                </td>
              }
            </tbody>
          </table>
        </div>
      </div>
      <!-- Brand Sales -->
      <div class="col-12 col-md-6">
        <div class="inner-card card-brand h-100">
          <div class="d-flex align-items-center gap-2 mb-3">
            <fa-icon [icon]="faTag" class="text-muted icon-sm"></fa-icon>
            <span class="inner-card-title fw-smbold">Sales by Brand</span>
          </div>
          <table class="table table-borderless mb-0 bg-transparent">
            <thead>
              <tr class="custom-tr">
                <th class="table-header-text p-1 pb-2 text-muted bg-transparent border-0">Brand</th>
                <th class="table-header-text p-1 pb-2 text-muted text-end bg-transparent border-0">Vol</th>
                <th class="table-header-text p-1 pb-2 text-muted text-end bg-transparent border-0">Sales</th>
              </tr>
            </thead>
            <tbody>
              @if (brandSales.length) {
                @for (item of brandSales; track item) {
                  <tr class="custom-tr cursor-pointer" (click)="onRowClick('brand', item)">
                    <td class="td-col-1 p-1 pt-2 pb-2 bg-transparent">{{ item.label }}</td>
                    <td class="td-col-2 p-1 pt-2 pb-2 text-end fw-smbold bg-transparent">
                        {{ item.vol | customNumber }}
                    </td>
                    <td class="td-col-3 p-1 pt-2 pb-2 text-end bg-transparent">
                        {{ item.sales | customNumber }}
                    </tr>
                  }
                }
                @if (brandSales.length == 0) {
                  <td colspan="3" class="text-center py-4 border-0">
                    <p class="text-muted mb-0 small fw-bold">No data found.</p>
                  </td>
                }
              </tbody>
            </table>
          </div>
        </div>
        <!-- Tyre Size Sales -->
        <div class="col-12 col-md-6">
          <div class="inner-card card-tyre h-100">
            <div class="d-flex align-items-center gap-2 mb-3">
              <fa-icon [icon]="faRulerCombined" class="text-muted icon-sm"></fa-icon>
              <span class="inner-card-title fw-smbold">Sales by Tyre Size</span>
            </div>
            <table class="table table-borderless mb-0 bg-transparent">
              <thead>
                <tr class="custom-tr">
                  <th class="table-header-text p-1 pb-2 text-muted bg-transparent border-0">Tyre Size</th>
                  <th class="table-header-text p-1 pb-2 text-muted text-end bg-transparent border-0">Vol</th>
                  <th class="table-header-text p-1 pb-2 text-muted text-end bg-transparent border-0">Sales</th>
                </tr>
              </thead>
              <tbody>
                @if (tyreSizeSales.length) {
                  @for (item of tyreSizeSales; track item) {
                    <tr class="custom-tr cursor-pointer" (click)="onRowClick('size', item)">
                      <td class="td-col-1 p-1 pt-2 pb-2 bg-transparent">{{ item.label }}</td>
                      <td class="td-col-2 p-1 pt-2 pb-2 text-end fw-smbold bg-transparent">
                          {{ item.vol | customNumber }}
                      </td>
                      <td class="td-col-3 p-1 pt-2 pb-2 text-end bg-transparent">
                          {{ item.sales | customNumber }}
                      </td>
                    </tr>
                  }
                }
                @if (tyreSizeSales.length == 0) {
                  <td colspan="3" class="text-center py-4 border-0">
                    <p class="text-muted mb-0 small fw-bold">No data found.</p>
                  </td>
                }
              </tbody>
            </table>
          </div>
        </div>
        <!-- Vehicle Sales -->
        <div class="col-12 col-md-6">
          <div class="inner-card card-vehicle h-100">
            <div class="d-flex align-items-center gap-2 mb-3">
              <fa-icon [icon]="faTruckFast" class="text-muted icon-sm"></fa-icon>
              <span class="inner-card-title fw-smbold">Sales by Vehicle</span>
            </div>
            <table class="table table-borderless mb-0 bg-transparent">
              <thead>
                <tr class="custom-tr">
                  <th class="table-header-text p-1 pb-2 text-muted bg-transparent border-0">Vehicle</th>
                  <th class="table-header-text p-1 pb-2 text-muted text-end bg-transparent border-0">Vol</th>
                  <th class="table-header-text p-1 pb-2 text-muted text-end bg-transparent border-0">Sales</th>
                </tr>
              </thead>
              <tbody>
                @if (vehicleSales.length) {
                  @for (item of vehicleSales; track item) {
                    <tr class="custom-tr">
                      <td class="td-col-1 p-1 pt-2 pb-2 bg-transparent">{{ item.label || "Unknown" }}</td>
                      <td class="td-col-2 p-1 pt-2 pb-2 text-end fw-smbold bg-transparent">
                          {{ item.vol | customNumber }}
                      </td>
                      <td class="td-col-3 p-1 pt-2 pb-2 text-end bg-transparent">
                          {{ item.sales | customNumber }}
                      </td>
                    </tr>
                  }
                }
                @if (vehicleSales.length == 0) {
                  <td colspan="3" class="text-center py-4 border-0">
                    <p class="text-muted mb-0 small fw-bold">No data found.</p>
                  </td>
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>
    }
  </div>

  <!-- Modal Template -->
  <ng-template #salesModal let-modal>
    <div class="sales-modal-container">

      <!-- Fixed: Modal Header -->
      <div class="modal-header border-0 pb-0 d-flex justify-content-between align-items-center flex-shrink-0">
        <h5 class="fw-bold mb-0 heading-text">All Sales</h5>
        <div class="d-flex align-items-center gap-2">
          <button class="btn btn-sm app-btn-outline d-flex align-items-center gap-1" (click)="showFilters = !showFilters">
            <fa-icon [icon]="faFilter"></fa-icon>
            {{ showFilters ? 'Hide Filters' : 'Show Filters' }}
          </button>
          <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
        </div>
      </div>

      <!-- Fixed: Filters -->
      @if (showFilters) {
        <div class="filters-container mx-2 mx-md-3 mt-2 p-3 rounded border">
          <div class="row g-3 align-items-end">
            <div class="col-6 col-md-2">
              <label for="tyreSizeInput" class="filter-label mb-1">Tyre Size</label>
              <input id="tyreSizeInput" type="text" class="form-control form-control-sm filter-input"
                placeholder="Enter tyre size" [(ngModel)]="filters.tyreSize" (input)="onChangeFilter()">
              </div>
              <div class="col-6 col-md-2">
                <label for="tyreMakeInput" class="filter-label mb-1">Tyre Make</label>
                <input id="tyreMakeInput" type="text" class="form-control form-control-sm filter-input"
                  placeholder="Enter tyre make" [(ngModel)]="filters.tyreMake" (input)="onChangeFilter()">
                </div>
                <div class="col-6 col-md-2">
                  <label for="tyreModelInput" class="filter-label mb-1">Tyre Model</label>
                  <input id="tyreModelInput" type="text" class="form-control form-control-sm filter-input"
                    placeholder="Enter tyre model" [(ngModel)]="filters.tyreModel" (input)="onChangeFilter()">
                  </div>
                  <div class="col-6 col-md-2">
                    <label for="serviceInput" class="filter-label mb-1">Service</label>
                    <input id="serviceInput" type="text" class="form-control form-control-sm filter-input" placeholder="Enter service"
                      [(ngModel)]="filters.service" (input)="onChangeFilter()">
                    </div>
                    <div class="col-6 col-md-2">
                      <label for="transactionTypeSelect" class="filter-label mb-1">Transaction Type</label>
                      <ng-select labelForId="transactionTypeSelect" [items]="transactionTypeList" bindLabel="name" bindValue="value"
                        [clearable]="true" [searchable]="false" placeholder="Select type..."
                        (change)="onChangeFilter()" [(ngModel)]="filters.stockOutType" class="custom-ng-select-sm">
                      </ng-select>
                    </div>
                    <div class="col-6 col-md-2">
                      <label for="createdBySelect" class="filter-label mb-1">Created By</label>
                      <ng-select labelForId="createdBySelect" [items]="usersList" bindLabel="name" bindValue="_id" [(ngModel)]="filters.createdBy" placeholder="Select user..."
                        (change)="onChangeFilter()" [clearable]="true" [searchable]="true" class="custom-ng-select-sm">
                      </ng-select>
                    </div>
                    <div class="col-6 col-md-2">
                      @if (isBranchVisible) {
                        <label for="branchSelect" class="filter-label mb-1">Branch</label>
                        <ng-select labelForId="branchSelect" [items]="branches" bindLabel="name" bindValue="_id" [(ngModel)]="filters.company"
                          (change)="onChangeFilter()" [clearable]="false" [searchable]="true" class="custom-ng-select-sm">
                        </ng-select>
                      }
                    </div>
                  </div>
                </div>
              }

              <!-- Scrollable: Table area -->
              <div class="modal-body p-2 p-md-3 pt-2 sales-table-body">
                <div class="table-responsive sales-table-scroll">
                  <table class="table custom-table align-middle m-0">
                    <!-- Fixed: Table header -->
                    <thead>
                      <tr>
                        <th class="fw-smbold border-0 text-start">Date</th>
                        @if(isBranchVisible && !filters.company){
                        <th class="fw-smbold border-0 text-center">Branch</th>
                        }
                        <th class="fw-smbold border-0 text-center">Type</th>
                        <th class="fw-smbold border-0 text-center">Partner</th>
                        <th class="fw-smbold border-0 text-center">Created By</th>
                        <th class="fw-smbold border-0 text-center">Description</th>
                        <th class="fw-smbold border-0 text-center">Quantity</th>
                        <th class="fw-smbold border-0 text-center">Total</th>
                        <th class="fw-smbold border-0 text-end">Invoice</th>
                      </tr>
                    </thead>
                    <tbody>
                      <!-- Loader State -->
                      @if (salesLoader) {
                        <tr>
                          <td [attr.colspan]="(isBranchVisible && !filters.company) ? 9 : 8" class="text-center py-5 border-0">
                            <app-loader [loadingIcon]="salesLoader"></app-loader>
                          </td>
                        </tr>
                      }

                      <!-- Error State -->
                      @if (!salesLoader && salesErrMsg) {
                        <tr>
                          <td [attr.colspan]="(isBranchVisible && !filters.company) ? 9 : 8" class="text-center py-4 border-0">
                            <p class="text-danger mb-0 small fw-bold">{{ salesErrMsg }}</p>
                          </td>
                        </tr>
                      }

                      <!-- Empty State -->
                      @if (!salesLoader && !salesErrMsg && allSales.length === 0) {
                        <tr>
                          <td [attr.colspan]="(isBranchVisible && !filters.company) ? 9 : 8" class="text-center py-4 border-0">
                            <p class="text-muted mb-0 small fw-bold">No sales data found.</p>
                          </td>
                        </tr>
                      }

                      <!-- Data -->
                      @if (!salesLoader && !salesErrMsg && allSales.length > 0) {
                        @for (order of allSales; track order) {
                          @for (item of order.allRows; track item; let i = $index) {
                            <tr>
                              @if (i === 0) {
                                <td [attr.rowspan]="order.totalRows" class="col-1-text border-0 text-start bottom-border">{{ order.created | date:'dd-MM-yyyy':'Asia/Kolkata' }}</td>
                                @if(isBranchVisible && !filters.company) {
                                  <td [attr.rowspan]="order.totalRows" class="col-3-text fw-bold text-end border-0 text-center bottom-border">{{ order.branch }}</td>
                                }
                              }
                              
                              <!-- TYPE Column -->
                              @if (item.itemType === 'stock') {
                                @if (i === 0) {
                                  <td [attr.rowspan]="order.stockCount" class="col-1-text border-0 text-center bottom-border" [class.bottom-border]="!order.serviceCount">
                                    {{ item.type }}
                                  </td>
                                }
                              }
                              @if (item.itemType === 'service') {
                                @if (i === order.stockCount) {
                                  <td [attr.rowspan]="order.serviceCount" class="col-1-text border-0 text-center bottom-border">
                                    {{ item.type }}
                                  </td>
                                }
                              }

                              @if (i === 0) {
                                <td [attr.rowspan]="order.totalRows" class="col-1-text border-0 text-center bottom-border">{{ order.customerName || order.dealerName || '-' }}</td>
                                <td [attr.rowspan]="order.totalRows" class="col-1-text border-0 text-center bottom-border">{{ order.user }}</td>
                              }
                              <td class="col-1-text border-0 text-center" [class.bottom-border]="i === order.allRows.length - 1">{{ item.description }}</td>
                              <td class="col-2-text fw-smbold text-end border-0 text-center" [class.bottom-border]="i === order.allRows.length - 1">
                                  {{ item.qty | customNumber }}
                              </td>
                              <td class="col-3-text fw-bold text-end border-0 text-center" [class.bottom-border]="i === order.allRows.length - 1">
                                  {{ item.total | customNumber: 'currency' }}
                              </td>
                              @if (i === 0) {
                                <td [attr.rowspan]="order.totalRows" class="col-3-text fw-bold text-end border-0 bottom-border">
                                   <span [ngClass]="{'text-primary cursor-pointer': order.invoice}"
                                     (click)="viewVoucher(order, pdfModal)">
                                     {{ order.invoiceNo }}
                                   </span>
                                  @if (order.paymentMode) {
                                  <div class="text-muted small mt-1 text-end" style="font-size: 10px; font-weight: normal;">
                                    Payment Mode - {{ order.paymentMode }}
                                  </div>
                                  }
                                 </td>
                              }
                            </tr>
                          }
                        }
                      }
                    </tbody>
                  </table>
                </div>
              </div>

            </div>
          </ng-template>


          <!-- PDF Viewer Modal -->
          <ng-template #pdfModal let-modal>
            <div class="app-pdf-model">
              <div class="modal-header">
                <h3>{{ selectedVoucher.name }}</h3>
                <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
              </div>
              <div class="modal-body p-0">
                 <iframe [src]="selectedVoucher.url" class="pdf-iframe" title="PDF Document Viewer"></iframe>
              </div>
            </div>
          </ng-template>
